import { AxiosInstance } from 'axios'

export enum EKbaKey {
  MOTHER_NAME = 'MOTHER_NAME',
  BIRTHDAY = 'BIRTHDAY',
  FULLNAME = 'FULLNAME',
}

export type OptionsDto = {
  kind: EKbaKey
  value: string
}

export type CreateKba = {
  id: number
  options: OptionsDto[]
}

export type RetrieveKba = CreateKba & {
  attemptsNumber: number
  userIsBlocked: boolean
}

export type CheckKbaAnswer = {
  kbaId: number
  status: boolean
  attemptsNumber: number
  userIsBlocked: boolean
}

export function kbaEndpoints(apiClient: AxiosInstance) {
  return {
    async createPhysicianKba(cpf: string): Promise<CreateKba> {
      return apiClient.post('create-physician-kba', { cpf })
    },

    async retrieveKbaData(cpf: string): Promise<RetrieveKba | null> {
      return apiClient.post('retrieve-kba-data', { cpf })
    },

    async checkKbaAnswer(data: { kbaId: number; kind: EKbaKey; value: string }): Promise<CheckKbaAnswer> {
      return apiClient.post('check-kba-answer', data)
    },
  }
}
